import { useConversationLandingOnboardingStore } from 'stores/conversation'
import ConversationLandingVariantA from './ConversationLandingVariantA'
import ConversationLandingVariantB from './ConversationLandingVariantB'

const CONVERSATION_LANDING = {
  variant_1: ConversationLandingVariantA,
  variant_2: ConversationLandingVariantB,
  control: () => <></>,
}
const ConversationLanding = () => {
  const { landingOnboardingVariant } = useConversationLandingOnboardingStore()

  const ConversationLanding =
    CONVERSATION_LANDING?.[landingOnboardingVariant] ??
    CONVERSATION_LANDING['control']

  return <ConversationLanding />
}

export default ConversationLanding
